export const DEFAULT_VEHICLE_IMAGE_URL = 'https://storage.googleapis.com/wicar-assets-mobile/car-default-image.png'
